// extracted by mini-css-extract-plugin
export default {"bowl-game-item":"bowl_bowl-game-item__Od9a5","bowl-card":"bowl_bowl-card__weZST","bowl-details":"bowl_bowl-details__9wzRc","matchup":"bowl_matchup__mnRHL","logo":"bowl_logo__WdFRO"};